module.exports = __webpack_public_path__ + "img/ic_16_extern.2f4e4ff1.svg";